import {
	Accordion,
	CategoryIcon,
	ToggleGroup,
} from "@au-schein-de/au-ui-library";
import { useTranslation } from "react-i18next";
import { FilterHeader } from "../filter-header.component";
import { useFiltersContext } from "../filters.context";

export function CategoriesFilter() {
	const { t } = useTranslation("product");
	const { filters, config, onFilterChange } = useFiltersContext();
	const value = filters.category;

	const handleToggle = (categoryValue: string) => {
		if (categoryValue) {
			onFilterChange("category", [Number.parseInt(categoryValue)]);
			return;
		}
		onFilterChange("category", undefined);
	};

	return (
		<Accordion.Item
			value="categories"
			variant="filter"
			data-testid="categories-filter"
		>
			<Accordion.Trigger
				variant="filter"
				data-testid="categories-filter-trigger"
			>
				<FilterHeader
					title={t("filters.category")}
					value={value ? 1 : undefined}
					icon={<CategoryIcon size={5} />}
				/>
			</Accordion.Trigger>
			<Accordion.Content variant="filter">
				<ToggleGroup.Root
					type="single"
					variant="secondary"
					size="xs"
					className="flex-wrap justify-start gap-2"
					value={value?.[0]?.toString() ?? ""}
					onValueChange={handleToggle}
				>
					{config.categories.map((category) => (
						<ToggleGroup.Item key={category.id} value={category.id.toString()}>
							{t(`filters.category.${category.name}`, {
								defaultValue: category.name,
							})}
						</ToggleGroup.Item>
					))}
				</ToggleGroup.Root>
			</Accordion.Content>
		</Accordion.Item>
	);
}
